export function parseNamedTag(tag: string): {
  id: string
  name: string
} {
  // split off the human name (if any)
  const [id, namePart] = tag.split('::', 2)

  return {
    id,
    name: namePart || id,
  }
}
